import React from 'react';
import styled from 'styled-components';
import Tooltip from '@mui/material/Tooltip';
import { COLORS } from '../design-system/settings/variables/Colors';
import { SPACERS } from '../design-system/settings/variables/Spacers';
import { useUserActions } from '../auth/hooks/useUserActions';

const REPORT_QUESTIONS_URL =
  '/docs/V4_True.Impact.Report.Builder.Questions.pdf';
export const PARTNER_REPORT_QUESTIONS_URL =
  '/docs/ReportBuilderWorksheet-Fillable_4.pdf';
const onClick = () => window.open(REPORT_QUESTIONS_URL, '_blank');
const onClickCN = () => window.open(PARTNER_REPORT_QUESTIONS_URL, '_blank');

interface DownloadReportQuestionsProps {
  text: string;
  className?: string;
  isButton: boolean;
}

const StyledDiv = styled.div`
  button {
    font-size: 14px;
    cursor: pointer;
    max-width: 160px;
    color: ${COLORS.ctaPrimary};
    background-color: transparent;
    border-radius: ${SPACERS.extraTiny};
    border: 1px solid ${COLORS.ctaPrimary};
    padding: ${SPACERS.tiny} ${SPACERS.small};
    transition: background-color 0.3s ease;
    &:hover {
      background-color: ${COLORS.ctaPrimaryBackground};
    }
  }
`;

const tooltipTitle =
  'If you prefer, click the link to download the report questions and draft your responses before walking through the report builder.';
const DownloadReportQuestions: React.FC<DownloadReportQuestionsProps> = ({
  text,
  isButton,
  className,
}) => {
  const { isThirdParty } = useUserActions();
  if (isButton) {
    return (
      <Tooltip title={tooltipTitle} arrow={true}>
        <StyledDiv className={className}>
          <button onClick={isThirdParty ? onClickCN : onClick}>{text}</button>
        </StyledDiv>
      </Tooltip>
    );
  }
  return (
    <Tooltip title={tooltipTitle} arrow={true}>
      <StyledDiv className={className}>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={isThirdParty ? PARTNER_REPORT_QUESTIONS_URL : REPORT_QUESTIONS_URL}
        >
          {text}
        </a>
      </StyledDiv>
    </Tooltip>
  );
};

export default DownloadReportQuestions;
